// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Un contrat est décrit par :\n\n- Le type (apprentissage et/ou professionnalisation).\n- La date de début.\n- La durée.\n- Le mode de travail (présentiel, télétravail ou hybride).\n"
export default markdown
